export default __webpack_public_path__ + "static/media/NeptuneDB.e9d1b816.svg";